(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-video"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pxu-video]').forEach(($root) => {
  const $dataScript = $root.querySelector('script[data-component-data]');
  const data = $dataScript ? JSON.parse($dataScript.textContent) : {};

  const $overlay = $root.querySelector('[data-pxu-video-overlay]');
  const $btn = $root.querySelector('[data-pxu-video-btn]');
  const $shopifyVideo = $root.querySelector('.pxu-video__video');

  function handleClick(e) {
    e.preventDefault();
    if ($overlay) {
      $overlay.style.opacity = 0;
      $overlay.style.pointerEvents = 'none';
    }

    if (data.videoType === 'youtube') {
      const $video = $root.querySelector('[data-pxu-video-youtube]');
      if ($video) $video.src += '&autoplay=1';
    } else if (data.videoType === 'vimeo') {
      const $video = $root.querySelector('[data-pxu-video-vimeo]');
      if ($video) $video.src += '&autoplay=1';
    } else if (data.videoType === 'shopify_hosted') {
      if ($shopifyVideo) {
        $shopifyVideo.play();
        $shopifyVideo.setAttribute('controls', '');
      }
    }
  }

  if ($btn) {
    $btn.addEventListener('click', handleClick);
  }

  function initYouTube() {
    const $ytPlaceholder = $root.querySelector('[data-youtube-placeholder]');
    if (!$ytPlaceholder) return;
    const ytAttributeString = $ytPlaceholder.dataset.attributeString;
    const ytTitle = $ytPlaceholder.dataset.title || '';
    $ytPlaceholder.innerHTML = `
      <iframe
        class="pxu-video__video"
        src="https://www.youtube.com/embed/${data.videoId}?${ytAttributeString}"
        allow="autoplay; encrypted-media"
        allowfullscreen
        title="${ytTitle}"
        data-pxu-video-youtube
      ></iframe>
    `;
  }

  function initVimeo() {
    const $vimeoPlaceholder = $root.querySelector('[data-vimeo-placeholder]');
    if (!$vimeoPlaceholder) return;
    const vimeoAttributeString = $vimeoPlaceholder.dataset.attributeString;
    $vimeoPlaceholder.innerHTML = `
      <iframe
        class="pxu-video__video"
        src="https://player.vimeo.com/video/${data.videoId}?${vimeoAttributeString}"
        allow="autoplay; encrypted-media"
        allowfullscreen
        data-pxu-video-vimeo
      ></iframe>
    `;
  }

  function initVideo() {
    switch (data.videoType) {
      case 'youtube':
        initYouTube();
        break;
      case 'vimeo':
        initVimeo();
        break;
      case 'shopify_hosted':
        if (data.enableVideoAutoplay && $shopifyVideo) {
          $shopifyVideo.play();
        }
        break;
      default:
        console.error('Unsupported video type:', data.videoType);
    }
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        initVideo();
        obs.unobserve($root);
      }
    });
  }, { threshold: 0 });
  observer.observe($root);
});

  } catch(e) { console.error(e); }
})();
})();
